
angular.module('procommTalentSearch').controller('TalentSearchController', function ($scope, procommService, pcShareService, procommPlaylistService, procommFavoriteService) {
  var talentSearch = this
  testscope = this

  testscope.scope = $scope

  talentSearch.procommService = procommService

  $scope.procommService = procommService
  $scope.pcShareService = pcShareService
  $scope.procommPlaylistService = procommPlaylistService
  $scope.procommFavoriteService = procommFavoriteService

  // PRC NEW
  $scope.searchState = talentSearch.procommService.searchState
  $scope.service = procommService

  $scope.output_ages = []
  $scope.output_styles = []

  $scope.getParam = function (parameterName) {
    var result = null
    var tmp = []
    location.search
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=')
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
      })
    return result
  }

  // CHECK URL ON LOAD
  if ($scope.getParam('style')) {
    $scope.searchState.style = $scope.getParam('style')
  }

  if ($scope.getParam('party')) {
    $scope.searchState.party = $scope.getParam('party')
  }

  if ($scope.getParam('age')) {
    $scope.searchState.age_range = $scope.getParam('age')
  }

  if ($scope.getParam('gender')) {
    $scope.searchState.gender = $scope.getParam('gender')
  }

  if ($scope.getParam('language')) {
    $scope.searchState.language = $scope.getParam('language')
  }

  $scope.text_search_mode = false
  $scope.previous_search_style = false
  $scope.previous_search_age_range = false
  $scope.previous_search_gender = false
  $scope.previous_search_language = false

  $scope.$watch('searchState', function (newValue, oldValue) {
    talentSearch.itemLimit = 30

    if (newValue.language != oldValue.language) {
      $scope.init()
    }

    if ($scope.searchState.search_text) {
      // If we want to clear out search, it would happen here.
      if (!$scope.text_search_mode) {
        $scope.previous_search_style = $scope.searchState.style
        $scope.previous_search_age_range = $scope.searchState.age_range
        $scope.previous_search_gender = $scope.searchState.gender
        $scope.previous_search_language = $scope.searchState.language
        $scope.text_search_mode = true
      }

      $scope.searchState.style = ''
      $scope.searchState.age_range = ''
      $scope.searchState.gender = ''
      $scope.searchState.language = ''
    } else {
      if ($scope.text_search_mode) {
        $scope.text_search_mode = false
        $scope.searchState.style = $scope.previous_search_style
        $scope.searchState.age_range = $scope.previous_search_age_range
        $scope.searchState.gender = $scope.previous_search_gender
        $scope.searchState.language = $scope.previous_search_language
      }
    }

    if($scope.searchState.style){
      
      const matching_style = $scope.output_styles.find(function(style){
        if(style.value == $scope.searchState.style){
          return style;
        }
        else{
          return false;
        }
      });

      if(matching_style.party){
        // console.log("PARTY EXISTS");
        $scope.searchState.party = matching_style.party;
      }
      else{
        $scope.searchState.party = false;
      }

        // style => style.value == $scope.searchState.style);
      // console.log('prcresult', matching_style);
    }
    else{
      $scope.searchState.party = false;
    }

    // talentSearch.demo = newValue.demo;
  }, true)
  // END PRC NEW

  $scope.update_in_progress = false

  $scope.increaseItemLimit = function () {
    // if(! $scope.update_in_progress){
    // $scope.update_in_progress = true;
    talentSearch.itemLimit = talentSearch.itemLimit + 30
    // }

    // setTimeout(function(){ $scope.update_in_progress = false}, 0);
  }

  talentSearch.default_style = 'Commercial'

  talentSearch.itemLimit = 30

  $scope.isPlayingState = talentSearch.procommService.isPlayingState

  talentSearch.isPlaying = talentSearch.procommService.isPlayingState
  talentSearch.demo = talentSearch.procommService.isPlayingState.demo
  $scope.demo = talentSearch.procommService.isPlayingState.demo

  talentSearch.talent = talentSearch.procommService.isPlayingState.talent

  $scope.$watch('isPlayingState', function (newValue, oldValue) {
    // console.log('tsgo1', newValue, oldValue, newValue.demo, typeof newValue.demo.file);

    talentSearch.demo = newValue.demo

    if (typeof newValue.demo.file !== typeof undefined) {
      jQuery('body').addClass('player-active')
    }
  }, true)

  talentSearch.setNonce = function (input) {
    procommPlaylistService.nonce = input
    procommFavoriteService.nonce = input
    procommPlaylistService.state.wp_current_user_id = wp_current_user_id
    procommFavoriteService.state.wp_current_user_id = wp_current_user_id
    procommPlaylistService.loadPlaylists()
    procommFavoriteService.loadFavorites()
  }

  talentSearch.setUser = function (input) {
    procommService.user = input
  }

  talentSearch.dataLoaded = function () {
    console.log('data loaded')

    // PRC TESTING
    talentSearch.talentList = test123
    talentSearch.demo_languages = demo_languages

    talentSearch.procommService.talentList = talentSearch.talentList

    talentSearch.procommService.search_results = talentSearch.talentList.filter(talentSearch.criteriaMatch(false))
    talentSearch.procommService.isPlayingState.talent = talentSearch.procommService.search_results[0]

    if (window.location.hash) {
      // check for demo
      // var active_demo_id = window.location.hash.replace("#demo=", "");

      // if(active_demo_id){
      //   for(index in talentSearch.talentList[0].demos){
      //     var demo = talentSearch.talentList[0].demos[index];
      //     if(active_demo_id == demo.ID){
      //       $scope.isPlayingState.demo = demo;
      //               console.log('active d', demo);
      //     }
      //   }
      // }
    }

    if (!$scope.isPlayingState.demo) {
      $scope.isPlayingState.demo = talentSearch.procommService.search_results[0].primary_demo
    }
    // console.log(isPlayingState.demo );
  }

  $scope.$watch('style', function (newValue, oldValue) {
    console.log('style go!')

    // talentSearch.isPlayingState.search
  }, true)

  // talentSearch.dataLoaded = function(){
  //   talentSearch.procommService.talentList = talentSearch.talentList;
  // };

  talentSearch.secondaryDemoCriteria = function (talent) {
    var searchState = $scope.searchState
    var firstDemo = $scope.getFirstDisplayedDemo(talent)

    return function (item) {
      if (searchState.favorites && !procommFavoriteService.isFavorite(item.ID)) {
        return false
      }

      if (item.ID == firstDemo.ID) {
        return false
      }

      return true
    }
  }

  talentSearch.criteriaMatch = function (criteria) {
    return function (item) {
      var searchState = $scope.searchState

      item.expanded = false
      if (item.demos.length == 0) {
        return false
      }
      // console.log(item.demos.length);

      // Favorites overrides all other filters
      if (searchState.favorites) {
        var demo_matches = false

        for (index in item.demos) {
          var a_demo = item.demos[index]
          if (procommFavoriteService.isFavorite(a_demo.ID)) {
            demo_matches = true
            // item.demos.push(item.primary_demo);
            // item.primary_demo = a_demo;
            if (a_demo.ID != item.primary_demo.ID) {
              item.expanded = true
            }

            return true
            // break;
          }
        }
        if (!demo_matches) {
          return false
        }

        // if(searchState.style){
        //   console.log(item.demos_by_style[searchState.style]);
        //   if(typeof item.demos_by_style[searchState.style] == typeof undefined){
        //     return false;
        //   }
        //   if(! procommFavoriteService.isFavorite(item.demos_by_style[searchState.style][0].ID) ){
        //     return false;
        //   }
        // }
        // else{
        //   var demo_matches = false;
        //   for(index in item.demos){
        //     var a_demo = item.demos[index];
        //     if(procommFavoriteService.isFavorite(a_demo.ID) ){
        //       demo_matches = true;
        //       // item.demos.push(item.primary_demo);
        //       // item.primary_demo = a_demo;
        //       if(a_demo.ID != item.primary_demo.ID){
        //         item.expanded = true;
        //       }
        //       break;
        //     }
        //   }
        //   if(! demo_matches){
        //     return false;
        //   }
        // }
      }

      // Search state overrides all other filters
      // 11.2.2017 JESSE added search_text.toLowerCase() to make not case sensitive
      if (searchState.search_text) {
        if (item.post_title.toLowerCase().indexOf(searchState.search_text.toLowerCase()) == -1) {
          return false
        } else {
          return true
        }
      }

      if (searchState.gender) {
        if (item.gender.toLowerCase() != searchState.gender.toLowerCase()) {
          return false
        }
      }

      if (searchState.style && ! searchState.party) {
        if (typeof item.demos_by_style[searchState.style] === typeof undefined ||
                item.demos_by_style[searchState.style].length == 0) {
          return false
        }
      }

      if (searchState.party) {
        // console.log("CRITERIA MATCH PARTY");
        if(typeof item.demos_by_style["Political"] === typeof undefined){
          return false;
        }

        const matching_party_demo = item.demos_by_style["Political"].find(function(demo){
          if(searchState.party == demo.party.toLowerCase() || (searchState.party != 'any' && demo.party.toLowerCase() == "any") ){
            return demo
          }
          else{
            return false;
          }
        });

        if(! matching_party_demo){
          return false;
        }
      }

      if (searchState.age_range) {
        if (item.age_range.indexOf(searchState.age_range) == -1) {
          return false
        }
      }

      if (searchState.language && typeof item.demos_by_language !== typeof undefined) {
        if (typeof item.demos_by_language[searchState.language] === typeof undefined ||
                item.demos_by_language[searchState.language].length == 0) {
          return false
        }
      }

      // Otherwise, it's a match!
      return true
    }
  }

  talentSearch.doShare = pcShareService.showShareDialog
  talentSearch.openPlaylistMenu = procommPlaylistService.showDialog

  talentSearch.playDemo = function (talent, demo) {
    console.log('DOPLAY')
    var isPlayingState = $scope.isPlayingState

    if (talentSearch.procommService.isPlayingState.status && talentSearch.procommService.isPlayingState.demo == demo) {
      isPlayingState.status = false
    } else {
      isPlayingState.status = true
      isPlayingState.demo = demo
      isPlayingState.talent = talent
    }
  }

  talentSearch.downloadDemo = function (talent, demo) {
    window.open('/wp-json/procomm/v1/download_demo/' + demoID, '_blank')
  }

  // STUFF THAT JESSE WROTE
  talentSearch.expandDemo = function (talent) {
    // return talent;
    // this.expanded = (this.expanded === talent ? null : talent);
    // return;

    var tempobj = this

    if (this.expanded === talent) {
      jQuery('.row__secondary').slideUp('fast', function () {
        tempobj.expanded = false
        tempobj.scope.$applyAsync()
      })
    } else {
      // this.expanded = (this.expanded === talent ? null : talent);
      this.expanded = talent

      // PRC - REVISIT THIS
      setTimeout(function () {
        jQuery('.row__secondary').slideDown()
      }, 500)
    }
  }

  talentSearch.isExpanded = function (talent) {
    return this.expanded === talent
  }

  // END STUFF THAT JESSE WROTE

  $scope.getActiveDemo = function (talent, demo) {
    if (demo.ID) {
      return demo
    } else {
      return $scope.getFirstDisplayedDemo(talent)
    }
  }

  $scope.searchFieldIsDefault = function (field) {
    return $scope.searchState[field] == $scope.service.defaultSearchState[field]
  }

  $scope.resetLanguage = function () {
    $scope.searchState.language = $scope.service.defaultSearchState.language
  }

  $scope.resetStyle = function () {
    if ($scope.output_styles.length == 1) {
      $scope.searchState.style = $scope.output_styles[0].value
    } else {
      $scope.searchState.style = $scope.service.defaultSearchState.style
    }
    $scope.searchState.party = false;
  }

  $scope.resetAge = function () {
    if ($scope.output_ages.length == 1) {
      $scope.searchState.age_range = $scope.output_ages[0].value
    } else {
      $scope.searchState.age_range = $scope.service.defaultSearchState.age_range
    }
  }

  $scope.shouldLanguageResetStyle = function (option_name) {
    var current_language = false

    if (typeof demo_languages[option_name] !== typeof undefined) {
      current_language = demo_languages[option_name]
    }

    if (current_language) {
      if (
        current_language.language_dim_others
      ) {
        return true
      }
    }

    return false
  }

  $scope.isFilterOptionDisabled = function (field, option_name) {
    var current_language = false

    if (typeof demo_languages[option_name] !== typeof undefined) {
      current_language = demo_languages[option_name]
    }

    if (current_language) {
      if (
        current_language.language_dim_others &&
          ($scope.searchState.style || $scope.searchState.age_range)
      ) {
        return true
      }
    }

    return false
  }

  $scope.getActiveStyles = function () {
    var current_language = false

    if (typeof demo_languages[$scope.searchState.language] !== typeof undefined) {
      current_language = demo_languages[$scope.searchState.language]
    }

    if (current_language) {
      // console.log('ACTIVE STYLES', current_language);

      $scope.output_styles = []
      if (current_language.language_style.length > 1) {
        $scope.output_styles.push({ value: '', name: 'Any' })
      }

      current_language.language_style.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase())
      })

      for (index in current_language.language_style) {
        var style = current_language.language_style[index]

        if(style == 'Political'){
          var any = 'Political - Any Party';
          var democrat = 'Political - Democrat';
          var republican = 'Political - Republican';
           $scope.output_styles.push({ value: any, name: any, party: 'any' }) 
           $scope.output_styles.push({ value: democrat, name: democrat, party: 'democrat' }) 
           $scope.output_styles.push({ value: republican, name: republican, party: 'republican' }) 

            // PRC Temp - add default
          // $scope.output_styles.push({ value: style, name: style })

        }
        else{
          $scope.output_styles.push({ value: style, name: style })
        }

      }

      if (current_language.language_style.length == 1) {
        $scope.searchState.style = $scope.output_styles[0].value
      }
    }
  }

  $scope.getActiveAges = function () {
    var current_language = false

    if (typeof demo_languages[$scope.searchState.language] !== typeof undefined) {
      current_language = demo_languages[$scope.searchState.language]
    }

    if (current_language) {
      // console.log('ACTIVE AGES', current_language);

      $scope.output_ages = []
      if (current_language.language_age.length > 1) {
        $scope.output_ages.push({ value: '', name: 'Any' })
      }

      // current_language.language_age.sort(function (a, b) {
      //   return a.toLowerCase().localeCompare(b.toLowerCase());
      // });

      for (index in current_language.language_age) {
        var age = current_language.language_age[index]
        $scope.output_ages.push({ value: age, name: age })
      }

      if (current_language.language_age.length == 1) {
        $scope.searchState.age_range = $scope.output_ages[0].value
      }
    }
  }

  $scope.isFilterDisabled = function (field) {
    if ($scope.searchState.language) {
      var current_language = false

      if (typeof demo_languages[$scope.searchState.language] !== typeof undefined) {
        current_language = demo_languages[$scope.searchState.language]
      }

      if (field == 'age' || field == 'style') {
        if (current_language.language_dim_others) {
          return true
        } else {
          return $scope.searchState.search_text.length || $scope.searchState.favorites
        }
      }
    } else {
      return $scope.searchState.search_text.length || $scope.searchState.favorites
    }
  }

  $scope.getDemoPartyText = function (party) {
    if(party.toLowerCase() == "any"){
      return "Any Party";
    }
    else{
      return party;
    }
  }


  $scope.getFirstDisplayedDemo = function (talent) {
    // if($scope.searchState.style && ! searchFieldIsDefault('language')){
    //   // If we have style and language
    // }

    if (typeof talent.playlist_mode !== typeof undefined && talent.playlist_mode) {
      return talent.primary_demo
    }

    // PRC 10.2021 - Added this to address issues with this fucnction with search style or language and favorites
    if (!$scope.searchState.favorites && $scope.searchState.style) {
      if ($scope.searchState.language) {
        for (index in talent.demos_by_style[$scope.searchState.style]) {
          var style_demo = talent.demos_by_style[$scope.searchState.style][index]
          if (style_demo.language_name == $scope.searchState.language) {
            return style_demo
          }
        }
      }

      if($scope.searchState.party){
        const matching_party_demo = talent.demos_by_style["Political"].find(function(demo){
          if($scope.searchState.party == demo.party.toLowerCase() || ($scope.searchState.party != "any" && demo.party.toLowerCase() == "any") ){
            return demo
          }
          else{
            return false;
          }
        });

        if(matching_party_demo){
          return matching_party_demo;
        }
      }
      else{
        return talent.demos_by_style[$scope.searchState.style][0]
      }
    } else {
      if ($scope.searchState.language) {
        if (talent.primary_demo.language_name == $scope.searchState.language) {
          return talent.primary_demo
        } else {
          if (typeof talent.demos_by_language !== typeof undefined && typeof talent.demos_by_language[$scope.searchState.language] !== typeof undefined) {
            return talent.demos_by_language[$scope.searchState.language][0]
          } else {
            return talent.primary_demo
          }
        }
      }

      return talent.primary_demo
    }
  }

  $scope.init = function () {
    $scope.getActiveAges()
    $scope.getActiveStyles()
  }

  $scope.init()

  $scope.procommFavoriteService = procommFavoriteService

  talentSearch.toggleFavorite = procommFavoriteService.toggleFavorite
  talentSearch.isFavorite = procommFavoriteService.isFavorite
})
